type Corner = "top-left" | "top-right" | "bottom-left" | "bottom-right";

interface CornerMarkProps {
	corner?: Corner;
	size?: number;
	className?: string;
}

const ROTATIONS: Record<Corner, string> = {
	"top-left": "rotate-0",
	"top-right": "rotate-90",
	"bottom-right": "rotate-180",
	"bottom-left": "-rotate-90",
};

/**
 * Small L-shaped SVG bracket decoration for card / hero corners.
 * Renders in currentColor — apply text-* to tint.
 */
export function CornerMark({ corner = "top-left", size = 16, className = "" }: CornerMarkProps) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
			className={`text-primary/40 ${ROTATIONS[corner]} ${className}`}
		>
			{/* L-shaped bracket: two strokes from the top-left corner */}
			<path d="M1 8 L1 1 L8 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" />
		</svg>
	);
}
